var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.classSlots.base(),attrs:{"type":"button"},on:{"click":(event) => _vm.$emit('click', event)}},[_c('UiIcon',{class:_vm.classSlots.icon(),attrs:{"name":_vm.icon,"solid":""}}),_c('span',{staticClass:"tw-ml-2",class:{ 'tw-hidden sm:tw-inline': _vm.responsive }},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }